import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/pliny/ui/Pre.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blogs/comments/Comments.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blogs/scroll/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blogs/seriescard/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blogs/share/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blogs/sidetoc/CustomTOC.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blogs/sidetoc/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blogs/tag/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdxcomponents/audioplayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/newletter/NewsletterForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/prism.css");
